import React from 'react';
import { Divider } from 'primereact/divider';
import { CodeHighlight } from './components2/CodeHighlight';

function Doc(props) {
    return (
        <div>
            <Divider layout="horizontal" align="center">
                <span className="p-tag">Contexte</span>
            </Divider>
            <p>Ce projet présente un modèle de gestion de parc automobile qui s'inspire 
                des règles de gestion du parc automobile au ministère de la santé du Bénin 
                où j'ai eu à travailler quelques années. Ce projet se concentre que sur 
                le processus de demande et d'affectation de véhicule de mission et se limite 
                à quelques règles d'affaires élementaires.</p>
            <Divider layout="horizontal" align="center">
                <span className="p-tag">Règles d'affaires</span>
            </Divider>
            <ul>
                <li>
                    Afin de disposer d'un véhicule pour se rendre à une mission, 
                    tout agent doit faire une demande de véhicules en mentionnant, la date de la mission, 
                    la durée de la mission, le motif de la mission et le nombre de sièges attendu dans 
                    le véhicule.
                </li>
                <li>
                    Toute demande de véhicule doit être approuvée dans un premier temps par 
                    le responsable de la division dans laquelle se trouve le demandeur du véhicule
                </li>
                <li>
                    Les demandes approuvées sont traitées ensuite par le chef parc. Ce dernier consulte
                    sa base de données pour voir la disponibilité de véhicules et de chauffeurs
                    pour la date de mission indiquée.
                </li>
                <li>
                    S'il existe une disponibilité, le chef parc répond favorablement en assignant 
                    un véhicule et un chauffeur à la demande. Dans le cas contraire la demande est 
                    rejetée pour motif de non disponibilité de véhicule ou de chauffeur.
                </li>
                <li>
                    Un véhicule et un chauffeur ne peuvent être assignés à plus d'une mission à la fois.
                </li>
            </ul>
            <Divider layout="horizontal" align="center">
                <span className="p-tag">Fonctionnalités</span>
            </Divider>
            <p>Les fonctionnalités impliquées dans le cadre de ce projet sont réparties suivant le profil utilisateur.</p>
            <h5>Simple utilisateur</h5>
            <p>Ce profil est celui des demandeurs de véhicule. Avec ce profil d'utilisateur,
                on peut :
                <ul>
                    <li>Soumettre une demande de véhicule</li>
                    <li>Consulter la réponse à sa demande de véhicule</li>
                    <li>Consulter le ou les véhicules affectés en cas de réponse favorable</li>
                </ul>
            </p>
            <h5>Responsable structure</h5>
            <p>Ce profil est celui des responsables de division. Avec ce profil d'utilisateur,
                on peut :
                <ul>
                    <li>Consulter les demandes de véhicules du personnel de sa division</li>
                    <li>Approuver ou rejecter des demandes de véhicules</li>
                    <li>Faire aussi une demande de véhicule au même titre qu'un utilisateur</li>
                </ul>
            </p>
            <h5>Chef parc</h5>
            <p>Ce profil est celui du chef du parc automobile. Avec ce profil d'utilisateur,
                on peut :
                <ul>
                    <li>Approuver une demande en assignant un véhicule et un chauffeur</li>
                    <li>Rejeter une demande</li>
                    <li>Consulter la disponibilité de véhicules et de chauffeurs</li>
                    <li>Mettre à jour la liste de véhicules disponibles</li>
                    <li>Mettre à jour la liste de chauffeurs disponible</li>
                    <li>...etc</li>
                </ul>
            </p>
            <Divider layout="horizontal" align="center">
                <span className="p-tag">Technologies utilisées</span>
            </Divider>
            <p>Cette plateforme est constituée d'une partie frontend développée avec <b>ReactJs </b>
                et d'une partie backend développée avec <b>Springboot</b> qui communique avec un serveur 
                de base de données <b>PostgreSQL</b>. Chaque application est empaquetée dans un conteneur 
                <b> Docker</b> pour faciliter le déploiement. L'hébergeur cloud utilisé ici pour 
                le déploiement est <a href='https://railway.com/'>Railway</a>. 
                Les apis du backend sont également documentés et sont disponibles au lien suivant :
                <a href='https://projet-msparc-api.chezgugu.com'> https://projet-msparc-api.chezgugu.com</a>

            </p>
            <Divider layout="horizontal" align="center">
                <span className="p-tag">Comptes de test</span>
            </Divider>
            <p>Voici quelques comptes que vous pouvez utiliser pour vous connecter à l'application afin de tester</p> 
            <CodeHighlight>{`
// profil CHEF_PARC
username: testeur3
password: testeur3

// profil RESPONSABLE_STRUCTURE
username: testeur2
password: testeur2

// profil SIMPLE_UTILISATEUR
username: testeur1
password: testeur1
            `}</CodeHighlight>

        </div>
    );
}

export default Doc;